import { queryOptions, type QueryClient } from "@tanstack/react-query";
import { api, unwrap } from "./api";

export const meQueryOptions = queryOptions({
  queryKey: ["me"],
  queryFn: async () => unwrap(await api.auth.me.get()),
  retry: false,
  staleTime: 5 * 60 * 1000,
});

/** Cached session if present; otherwise GET /auth/me. */
export function loadSession(queryClient: QueryClient) {
  return queryClient.query({
    ...meQueryOptions,
    staleTime: "static",
  });
}
